module.exports = __webpack_public_path__ + "static/confetti_bw.526f2969.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/confetti_bw.png
// module id = 1008
// module chunks = 35783957827783 110308036455227 263791100135453